<template>
    <div>
        <ob1-cards class="card-height bg-white shadow-none" :with-composite-link="false" @ob1-cards-click.stop>
            <!--/* Titre*/-->
            <a
                href="#"
                :data-oevent-category="trackZone"
                :data-oevent-action="'bloc_' + index"
                :data-oevent-label="tagLabel(device.name)"
                @click.prevent="handleClick"
            >
                <div class="px-1 pt-2">
                    <div class="d-flex flex-column align-items-center">
                        <span>{{ device.brand }}</span>
                        <p class="text-center mb-0 mx-1 font-weight-bold device-name-wrapper">{{ device.name }}</p>
                    </div>

                    <div class="img-mobile">
                        <!--/* Image */-->
                        <div class="mb-1 img-history-mobile-container">
                            <ob1-simple-image
                                v-if="device.image"
                                :visual="device.image"
                                css-classes="device-size"
                            />
                            <ob1-simple-image
                                v-if="device.imageOverlay"
                                :visual="device.imageOverlay"
                                class="img-history-mobile-overlay"
                                css-classes="technology-size"
                            />
                        </div>
                    </div>
                </div>
            </a>
        </ob1-cards>
        <!--/* Das */-->
        <das-tooltip
            v-if="device.dasAccessible"
            :id="'tooltip-history-' + index"
            :das="device.dasAccessible"
            class="mr-auto"
        />
    </div>
</template>

<script>
import DasTooltip from "../DasTooltip.vue";

const ACQUISITION_PARAM = "acquisition";
const PCM_PARAM = "pcm";
const RENOUVELLEMENT_PARAM = "renouvellement-terminal-seul";
const TSEUL_PARAM = "terminal-seul";

export default {
    name: "DeviceHistory",
    components: {DasTooltip},
    props: {
        device: {
            type: Object,
            required: true
        },
        trackZone: {
            type: String,
            required: true,
        },
        intention: {
            type: String,
            required: true
        },
        isFromMobileDetail: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            required: true
        }
    },
        computed: {
            detailLink() {
                switch(this.intention) {
                    case ACQUISITION_PARAM:
                        return this.device.detailAcqLink;
                    case PCM_PARAM:
                        return this.device.detailPcmLink;
                    case RENOUVELLEMENT_PARAM:
                        return this.device.detailRenewalLink;
                    case TSEUL_PARAM:
                        return this.device.detailTseulLink;
                }
                return null;
            }
        },
    methods: {
        handleClick() {
            const detailLink = this.detailLink;
            location.href = detailLink
            if (this.isFromMobileDetail) {
                window.location.replace(detailLink)
            } else {
                location.href = detailLink
            }
        },
        tagLabel(label) {
            return stripAccents(label).split(' ').join('_')
        },
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_common', 'ob1_variables';

.device-size {
    height: px-to-rem(195);
}

.technology-size {
    width: px-to-rem(30);
    height: px-to-rem(30);
}

.img-history-mobile-container {
    position: relative;
    width: px-to-rem(170);
    text-align: center;
    bottom: px-to-rem(14);
    height: px-to-rem(170);
}

.img-history-mobile-overlay {
    position: absolute;
    right: px-to-rem(-20);
    bottom: px-to-rem(-10);
}

.img-mobile {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: px-to-rem(10);
}
</style>
